import { useState } from 'react';

export function AddFacilityDialog({
  busy,
  error,
  onClose,
  onSubmit,
}: {
  busy: boolean;
  error: string | null;
  onClose: () => void;
  onSubmit: (input: { facilityName: string; location: string | null }) => void;
}) {
  const [facilityName, setFacilityName] = useState('');
  const [location, setLocation] = useState('');
  const valid = facilityName.trim().length > 0;

  return (
    <div className="r42-dialog-layer" role="dialog" aria-modal="true" aria-labelledby="add-facility-title">
      <button className="r42-dialog-backdrop" aria-label="Close add facility" onClick={busy ? undefined : onClose} />
      <form
        className="r42-dialog-card r42-facility-dialog"
        onSubmit={(event) => {
          event.preventDefault();
          if (valid && !busy) onSubmit({ facilityName: facilityName.trim(), location: location.trim() || null });
        }}
      >
        <span className="r42-eyebrow">Organization settings</span>
        <h2 id="add-facility-title">Add facility</h2>
        <p>Create a facility that can be assigned to machines and used to scope user access.</p>

        <label className="r42-field">
          <span className="r42-field__label">Facility name <b>Required</b></span>
          <input autoFocus maxLength={200} value={facilityName} onChange={(event) => setFacilityName(event.target.value)} placeholder="Plant 01" disabled={busy} />
        </label>
        <label className="r42-field">
          <span className="r42-field__label">Location</span>
          <input maxLength={500} value={location} onChange={(event) => setLocation(event.target.value)} placeholder="Atlanta, GA" disabled={busy} />
          <small>Optional physical location or site description.</small>
        </label>

        {error ? <div className="r42-form-alert" role="alert"><i className="bi bi-exclamation-circle" aria-hidden="true" /><div><strong>Facility could not be created.</strong><span>{error}</span></div></div> : null}

        <div className="r42-dialog-actions">
          <button type="button" className="btn btn-outline-secondary" onClick={onClose} disabled={busy}>Cancel</button>
          <button type="submit" className="btn r42-btn-primary" disabled={!valid || busy}>
            {busy ? <><span className="spinner-border spinner-border-sm" aria-hidden="true" /> Creating…</> : 'Add facility'}
          </button>
        </div>
      </form>
    </div>
  );
}
